module.exports = __webpack_public_path__ + "img/invoice.f81a1b6f.svg";